// @flow
import React, { type ElementRef, type Node } from 'react';
import AnimatingBorder from './AnimatingBorder';

type ReactObjRef<ElementType: React$ElementType> = {
  current: { findActive: () => void } | ElementRef<ElementType>
};

type Props = {
  className?: string,
  children: Node,
  activeSection: string
};
type State = {
  borderLeft: number,
  borderWidth: number,
  transitionActive: boolean
};

export default class TableTabs extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.animatingBorderRef = React.createRef();
  }
  animatingBorderRef: ReactObjRef<any>;

  componentDidUpdate(prevProps: Props) {
    if (this.props.activeSection !== prevProps.activeSection) {
      const animatingBorderRef = this.animatingBorderRef.current;
      animatingBorderRef.findActive();
    }
  }

  render() {
    return (
      <AnimatingBorder
        ref={this.animatingBorderRef}
        className={this.props.className}
      >
        {this.props.children}
      </AnimatingBorder>
    );
  }
}
